"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShimmerWrapper = exports.Shimmer = exports.SHIMMER_TYPE_TO_BORDER_RADIUS_MAP = exports.SHIMMER_TYPES = exports.KPIShimmer = void 0;
var React = _interopRequireWildcard(require("react"));
var _border = require("../../styles/variables/_border");
var _size = require("../../styles/variables/_size");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _string = require("../../utils/string");
var _ShimmerModule = _interopRequireDefault(require("./Shimmer.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const SHIMMER_TYPES = Object.freeze({
  text: 'text',
  rounded: 'rounded',
  circular: 'circular',
  rectangular: 'rectangular'
});
exports.SHIMMER_TYPES = SHIMMER_TYPES;
const SHIMMER_TYPE_TO_BORDER_RADIUS_MAP = Object.freeze({
  text: _border.borderRadiusXSmall,
  rounded: _border.borderRadiusMedium,
  circular: _border.borderRadiusCircle,
  rectangular: _border.borderRadiusNone
});
exports.SHIMMER_TYPE_TO_BORDER_RADIUS_MAP = SHIMMER_TYPE_TO_BORDER_RADIUS_MAP;
/**
 * Note(Nishant): ShimmerWrapper is a wrapper component for Shimmer component. This should only be used for Text based Shimmers
 * This solves a very annoying problem with out text components where the display prop is set to flex.
 * Genesis assumes that every element is flexible for simplicity and for text text shimmers to work in use cases
 * where text wraps across multiple lines, we need to wrap the shimmer in a span element.
 * to avoid the misuse where consumers use there own / other block level components, we have this wrapper.
 * This would ensure the layout remains same even when you toggle the shimmer to show your actual content
 * @param {React.Node} children - The children to be rendered
 */
const ShimmerWrapper = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("span", null, children);
};
exports.ShimmerWrapper = ShimmerWrapper;
const Shimmer = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    classNames,
    show = true,
    type = SHIMMER_TYPES.text,
    children,
    width = _size.size40,
    height = _size.sizeFluid,
    borderRadius
  } = _ref2;
  if (!show) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  const borderRadiusValue = borderRadius ?? SHIMMER_TYPE_TO_BORDER_RADIUS_MAP[type];
  return /*#__PURE__*/React.createElement("span", {
    ref: ref,
    "data-testid": "Shimmer",
    className: (0, _classify.default)(_ShimmerModule.default.wrapper, _ShimmerModule.default[type], classNames?.wrapper),
    style: {
      '--width': (0, _string.appendPx)(width),
      '--height': (0, _string.appendPx)(height),
      '--border-radius': (0, _string.appendPx)(borderRadiusValue)
    }
  });
});
exports.Shimmer = Shimmer;
const KPIShimmer = _ref3 => {
  let {
    textWidth = 150,
    hasBottomContent = true,
    hasIcon = true,
    hasTopContent = true,
    hasMiddleContent = true,
    classNames
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_ShimmerModule.default.kpiBox, classNames?.wrapper)
  }, hasIcon && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_ShimmerModule.default.section, _ShimmerModule.default.iconSection, classNames?.icon)
  }, /*#__PURE__*/React.createElement(Shimmer, {
    type: "rounded",
    width: 60,
    height: 60
  })), /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_ShimmerModule.default.section, classNames?.text)
  }, hasTopContent && /*#__PURE__*/React.createElement(Shimmer, {
    type: "text",
    width: textWidth,
    height: 15
  }), hasMiddleContent && /*#__PURE__*/React.createElement(Shimmer, {
    type: "text",
    width: textWidth,
    height: 25
  }), hasBottomContent && /*#__PURE__*/React.createElement(Shimmer, {
    type: "text",
    width: textWidth,
    height: 15
  })));
};
exports.KPIShimmer = KPIShimmer;